import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { Invoice, PaymentMethod } from '../../../types/items';
import {InvoiceCreateRequest, InvoiceRequest} from './types';

export const getPaymentMethodRequest = action(
  'GET_PAYMENT_METHOD_REQUEST',
  withPayload<number>(),
);

export const getPaymentMethodSuccess = action(
  'GET_PAYMENT_METHOD_SUCCESS',
  withPayload<PaymentMethod>(),
);

export const getPaymentMethodFail = action(
  'GET_PAYMENT_METHOD_FAIL',
  withoutPayload,
);

export const getInvoicesRequest = action(
  'GET_INVOICES_REQUEST',
  withPayload<InvoiceRequest>(),
);

export const getInvoicesSuccess = action(
  'GET_INVOICES_SUCCESS',
  withPayload<Invoice[]>(),
);

export const getInvoicesFail = action(
  'GET_INVOICES_FAIL',
  withoutPayload,
);

export const checkCheckoutProductsRequest = action(
  'CHECK_CHECKOUT_PRODUCTS_REQUEST',
  withPayload<number>(),
);

export const createNewInvoiceRequest = action(
  'CREATE_NEW_INVOICE_REQUEST',
  withPayload<InvoiceCreateRequest>(),
);

export const createNewInvoiceSuccess = action(
  'CREATE_NEW_INVOICE_SUCCESS',
  withoutPayload,
);

export const createNewInvoiceFail = action(
  'CREATE_NEW_INVOICE_FAIL',
  withoutPayload,
);
